import {SODeleteBlock} from '../../core/block/so-delete-block';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteBlock extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteBlock;
}